<template>
  <div>
    <div id="cont">
      <div id="name-label">
        <svg
          viewBox="0 0 12 10"
          preserveAspectRatio="xMaxYMid slice"
          class="svg-label"
        >
          <text
            x="12"
            y="7"
            font-size="4"
            text-anchor="end"
            dominant-baseline="middle"
          >
            {{ name }}
          </text>
        </svg>
      </div>
      <div id="min-label">
        <svg
          viewBox="0 0 12 10"
          preserveAspectRatio="xMaxYMid slice"
          class="svg-label"
        >
          <text
            x="10"
            y="5.5"
            font-size="3.5"
            text-anchor="end"
            dominant-baseline="middle"
          >
            {{ min }}
          </text>
        </svg>
      </div>
      <div class="thumb-val-cont">
        <svg
          class="thumb-val-svg"
          viewBox="0 0 10 10"
          :style="{ left: sliderLabelMargin }"
        >
          <text x="5" y="7" font-size="6" text-anchor="middle">
            {{ value }}
          </text>
        </svg>
      </div>
      <input
        type="range"
        :min="min"
        :max="max"
        v-model="value"
        class="slider"
        id="myRange"
        @input="updateValue($event.target.value)"
      />
      <div id="max-label">
        <svg
          viewBox="0 0 10 10"
          preserveAspectRatio="xMinYMid meet"
          class="svg-label"
        >
          <text
            x="2"
            y="5"
            font-size="4"
            text-anchor="start"
            dominant-baseline="middle"
          >
            {{ max }}
          </text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeSlider',
  props: {
    min: { default: 55, type: Number },
    max: { default: 70, type: Number },
    value: { default: 60, type: Number },
    name: { default: 'Upper' }
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value)
    }
  },
  computed: {
    sliderLabelMargin() {
      return ((this.value - this.min) / (this.max - this.min)) * 92 - 2 + '%'
    }
  }
}
</script>

<style scoped>
text {
  fill: black;
}
#cont {
  height: 100%;
  width: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 10% 74% 10%;
  column-gap: 3%;
  grid-template-rows: 50% 50%;
}
#name-label {
  grid-row: 1;
  grid-column: 1;
  height: 100%;
  width: 100%;
}
#min-label {
  grid-column: 1;
  grid-row: 2;
  height: 100%;
  width: 100%;
}
#max-label {
  grid-column: 3;
  grid-row: 2;
  height: 100%;
  width: 100%;
}
.svg-label {
  height: 100%;
  width: 100%;
}
.thumb-val-cont {
  grid-row: 1;
  grid-column: 2;
  height: 100%;
  width: 100%;
  overflow: visible;
  position: relative;
}
.thumb-val-svg {
  position: absolute;
  overflow: visible;
  height: 100%;
}
.slider {
  grid-column: 2;
  grid-row: 2;
  width: 100%;
}
.slider:focus {
  outline: none;
}
.slider::-webkit-slider-thumb {
  width: 1.7%;
  height: 2em;
  border-radius: 999px;
  border-width: 0;
  background: #00524c;
  cursor: pointer;
  -webkit-appearance: none;
}
[type='range'] {
  height: 1.5em;
  background: transparent;
}
[type='range'],
[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
}
[type='range']::-webkit-slider-runnable-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 96%;
  height: 0.75em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-moz-range-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 96%;
  height: 0.25em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-ms-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 100%;
  height: 0.25em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-webkit-slider-thumb {
  margin-top: -1.6em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 3.2em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-moz-range-thumb {
  margin-top: -1.6em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 3.2em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-ms-thumb {
  margin-top: 0;
  box-sizing: border-box;
  border: none;
  width: 0.5em;
  height: 1.2em;
  border-radius: 999px;
  background: #00524c;
}
</style>
